import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "17",
    height: "22",
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const CertificateRibbon = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M5.69 11.7L6.57 8.85L4.27 7H7.12L8.02 4.2L8.92 7H11.77L9.44 8.85L10.32 11.7L8.02 9.92L5.69 11.7ZM2.01 21V13.27C1.38 12.57 0.88 11.77 0.53 10.87C0.18 9.97 0 9.01 0 7.99C0.01 5.77 0.79 3.88 2.34 2.33C3.89 0.78 5.78 0 8.01 0C10.24 0 12.14 0.78 13.69 2.33C15.24 3.88 16.02 5.77 16.02 8.01C16.02 9.03 15.84 9.99 15.49 10.89C15.14 11.79 14.65 12.59 14.01 13.29V21.02L8.01 19.02L2.01 21.02V21ZM8.01 14C9.68 14 11.09 13.42 12.26 12.25C13.43 11.08 14.01 9.67 14.01 8C14.01 6.33 13.43 4.92 12.26 3.75C11.09 2.58 9.68 2 8.01 2C6.34 2 4.93 2.58 3.76 3.75C2.59 4.92 2.01 6.33 2.01 8C2.01 9.67 2.59 11.08 3.76 12.25C4.93 13.42 6.34 14 8.01 14ZM4.01 18.03L8.01 17L12.01 18.03V14.93C11.43 15.26 10.8 15.53 10.12 15.72C9.44 15.91 8.74 16.01 8.01 16.01C7.28 16.01 6.57 15.91 5.9 15.72C5.22 15.53 4.6 15.27 4.01 14.93V18.03Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default CertificateRibbon;
